import store from './../store';

export default (value, type) => store.getters.ENUM[type][value];



// WEBPACK FOOTER //
// ./sources/filters/enum.js